<template>
  <div class="demoPage">
    <!-- tab切换 -->
    <div class="navTabs fixed-content">
        <div class="tabs" @click="toPage('/studentRoomManger')">整体情况</div>
        <div class="tabs" @click="toPage('/floorSituation')">楼栋情况</div>
        <div class="tabs border-bottom-03a9f4 color-appStyle">学院分布表</div>
    </div>
    <div class="mt-content scroll-content">
        <div class="titleItem">
          <div class="font-size-28 bold">学院人数分布情况</div>
          <div class="dropdownBox">
              <p class="font-size-14px">选择类别：</p>
              <div id="trigger" class="dropdown font-size-14px">{{selectData.name}}</div>
              <img src="static/images/arrow.png">
          </div>
        </div>
        <div class="lineCharts">
           <chart id="charts" ref="chart" :options="orgOptions" :auto-resize="true"></chart>
        </div>
        <div class="font-size-28 bold">住房人数房间分布情况</div>
        <div class="tabContent">
            <div class="grid" style="padding-left: 0;padding-right: 0;">
            <div class="gridWarp bg-appStyle color-fff">
                <div class="gridCell flex-1 bold">宿舍区域</div>
                <div class="gridCell flex-1 bold">住1人</div>
                <div class="gridCell flex-1 bold">住2人</div>
                <div class="gridCell flex-1 bold">住3人</div>
                <div class="gridCell flex-1 bold">住4人</div>
            </div>

            <div v-if="dormAreaList.length > 0">
              <div class="gridWarp bg-fff" v-for="(item, index) in dormAreaList" :key="index">
                <div class="gridCell flex-1" :class="{'bold': item.zoneName == '总计'}">{{item.zoneName}}</div>
                <div class="gridCell flex-1">{{item.in1StudentCnt}}</div>
                <div class="gridCell flex-1">{{item.in2StudentCnt}}</div>
                <div class="gridCell flex-1">{{item.in3StudentCnt}}</div>
                <div class="gridCell flex-1">{{item.in4StudentCnt}}</div>
              </div>
            </div>

            </div>
        </div>
    </div>

  </div>
  
</template>

<script>
import MobileSelect from 'mobile-select';
import service from "@/fetch/service";
import ECharts from 'vue-echarts'
export default {
  components: {
    'ECharts': ECharts
  },
  data () {
    return {
      orgOptions: {},
      selectDataArr: [
        {
          id: '',
          value: '全部'
        },
        {
          id: '1',
          value: '本科生'
        },
        {
          id: '2',
          value: '研究生'
        }
      ],
      selectData: { //当前下拉框的值
        name: '全部',
        value: ''
      },
      dormAreaList: [],
      collegefbDataName: [],
      collegefbData: []
    }
  },
  created() {
    this.getDatas()
  },
  methods: {
    toPage: function(pageName) {
      this.$router.replace(pageName);
    },
    // 请求数据
    getDatas: function() {
      var that = this
      that.collegefbData = []
      that.collegefbDataName = []
      //统计宿学院人数分布情况和住房人数分布情况
      service
      .findStudentsFbqk({
        degreeType: that.selectData.value
      })
      .then(res => {
        if (res.success) {
          let total = 0
          res.result.collegefb.forEach(element => {
            that.collegefbData.push(element.cnt)
            that.collegefbDataName.push(element.collegeName)
            total += element.cnt
          });
          this.dormAreaList = res.result.roomZffb

          this.orgOptions = {
              grid: {
                  top: '12%',
                  left: '1%',
                  right: '10%',
                  // bottom: '15%',
                  containLabel: true
              },
              tooltip : {
                  trigger: 'axis',
                  axisPointer: {
                      type: 'shadow',
                      label: {
                          show: true
                      }
                  }
              },
              xAxis: [
                  {
                      type : 'category',
                      data :  this.collegefbDataName,
                      axisLabel: {
                          interval: 0,
                          rotate: 55
                      }
                  }
              ],
              yAxis: [
                  {
                      type : 'value',
                      name: '人数：' + total
                  }
              ],
              dataZoom: [
                  {
                      show: true,
                      start: 0,
                      end: 100,
                      bottom: '5%',
                      minSpan: 25,
                      maxSpan: 25
                  }
              ],
              series : [
                  {
                      name: '学院人数',
                      type: 'bar',
                      itemStyle: {
                          color: '#03a9f4'
                      },
                      barWidth: 15,
                      barMaxWidth: 40,
                      data: this.collegefbData
                  }
              ]
          }
        }
      })
      .catch(error => {
        console.log(error);
      });

    }
  },
  mounted() {
    let that = this
     var mobileSelect = new MobileSelect({
        trigger: "#trigger",
        title: "请选择类别",
        wheels: [
          {data: this.selectDataArr}
        ],
        callback:function(indexArr, data){
            that.selectData = {
              name: data[0].value,
              value: data[0].id
            }
            
            that.getDatas()
        }
    });
  }
}
</script>
<style lang="scss">
  @import "../assets/css/function";
  html, .demoPage, .mt-content {
    background: #f5f5f5;
  }
  $fixed-height: px2rem(80px);
  .border-bottom-03a9f4 {
    border-bottom: px2rem(5px) solid #03a9f4;
  }
  .demoPage {
    .mt-content {
      padding: px2rem(36px) px2rem(36px) px2rem(40px) px2rem(36px);
    }
    .fixed-content {
      height: calc(#{$fixed-height}) !important;
    }
    .scroll-content {
      top: calc(#{$fixed-height}) !important;
    }
    .mint-navbar .mint-tab-item, .mint-tab-item-label {
      height: $fixed-height;
      line-height: $fixed-height;
      padding: 0;
    }
    .titleItem {
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
    .dropdownBox {
      display: flex;
      align-items: center;
      // justify-content: 
      img {
        width: px2rem(30px);
        height: px2rem(30px);
        margin-left: px2rem(10px)
      }
    }
  }
  .lineCharts {
    margin-bottom: px2rem(40px);
    width: 100% !important;
    height: 320px !important;
  }
  .lineCharts > .echarts {
    width: 100% !important;
    height: 320px !important;
  }
</style>


// WEBPACK FOOTER //
// StudentRoomMangerTwo.vue?2a72f2ef